import React, { useEffect, useRef, useState } from 'react'
import { Scrollbars } from 'rc-scrollbars'
import { useTransition, animated } from '@react-spring/web'
import Markdown from 'react-markdown'
import { useApp,useCanvas } from 'store/AppStore'

import { ReactComponent as PlusIcon } from 'assets/uiIcons/plus.svg'
import { ReactComponent as MinusIcon } from 'assets/uiIcons/minus.svg'
import { ReactComponent as ChevronIcon } from 'assets/uiIcons/chevron-down.svg'

import { icons, images } from 'assets/features'

import {
  Body,
  FeatureBlock,
  FeatureItem,
  Head,
  ProductFeaturesRoot,
  Root,
  SmallMarkdown,
} from './FeatureBox.styled.js'
import Collapsible from 'components/Collapsible/index.jsx'
import { usePrevious } from 'react-use'

const ProductFeatures = ({ product, selected }) => {
  const { isStickText,setStickText } = useCanvas()
  const [chevronRotate, setChevronRotate] = useState(true)
  const scrollbarsRef = useRef()
  const titleScroll = useRef()
  const allTheRefs = useRef([])
  const [productFeature,setProductFeature] = useState(product.features) 

  useEffect(() => {
    if (selected) {
      scrollbarsRef.current.scrollToTop()
    }
  }, [selected])


  // on affiche le texte du stick uniquement si on est sur la derniere page
  useEffect(()=>{
    
    if (isStickText && product.id == 9){
      setProductFeature(product.features2)
    }else{
      setProductFeature(product.features)
    }

    if (isStickText && product.id != 9){
      setStickText(false);
    }
  },[isStickText,product])



  const handleUpdate = (values) => {
    const { scrollTop, scrollHeight, clientHeight } = values
    const rotate = scrollHeight - clientHeight - scrollTop > 10

    if (rotate !== chevronRotate) {
      setChevronRotate(rotate)
    }
  }

// use  scrollingTop(2);
  const scrollingTop = (id) => {
    if (allTheRefs.current[id])
      allTheRefs.current[id].scrollIntoView({
      behavior: "smooth",
    });
  };

  /*
  useEffect(() => {
    
    const modalBox = document.querySelector('#scrollaos');
    const allWithClass = Array.from(
        modalBox.querySelectorAll('.Title')
    );
    
    //allWithClass[2].scrollIntoView();

    scrollingTop(2);
  }, []);
*/


  return (
    <ProductFeaturesRoot chevronRotate={chevronRotate}>
      <Scrollbars id="scrollaos" ref={scrollbarsRef} onUpdate={handleUpdate}>
        <div className="Inner">
          {productFeature.map(({ title, blocks, centerTitle }, id) => (
            <FeatureItem key={id} centerTitle={centerTitle}>
              <div ref={ref => allTheRefs.current[id] = ref} className="Title">{title}</div>
              {blocks.map(({ text, subtitle,smallText, icon, image }, blockId) => (
                <FeatureBlock key={blockId} hasIcon={!!icon}>
                  {image && (
                    <div className="Image">
                      <img src={images[image]} alt="" />
                    </div>
                  )}
                  {icon && <div className="Icon">{icons[icon]}</div>}
                  {(text || smallText) && (
                    <div className="Text">
                      {subtitle && <div ref={titleScroll} className="Subtitle">{subtitle}</div>}
                      <Markdown>{text}</Markdown>
                      {smallText && <SmallMarkdown>{smallText}</SmallMarkdown>}
                    </div>
                  )}
                </FeatureBlock>
              ))}
            </FeatureItem>
          ))}
        </div>
      </Scrollbars>
      <div className="Footer">
        <div className="Icon">
          <ChevronIcon></ChevronIcon>
        </div>
      </div>
    </ProductFeaturesRoot>
  )
}
const FeatureBox = () => {
  const { products, selectedProductIndex, showFeatures, toggleFeatures, isShort, isPortrait } =
    useApp()
  const { isStickText } = useCanvas()
  const [previousOpen, setPreviousOpen] = useState(false);
  const previousIndex = usePrevious(selectedProductIndex)


  // si c'est fermet on ouvre le panneau pour afficher les info du stick
  useEffect(()=>{
    if (showFeatures && isStickText){
      setPreviousOpen(true)
      //console.log('------------------------SAVE PREVIOUS')
    }
    if (!showFeatures && isStickText){
      setPreviousOpen(false)
      toggleFeatures()
      // pour l'AOS determine si le panneau est deja ouvert
      window.utalk.isreadingkmoreAlreadyOpen = true;
      //console.log('------------------------OPEN')
    }
    // on check si on doit la refermer
    if (showFeatures && !isStickText && !previousOpen){
      toggleFeatures()
      window.utalk.isreadingkmoreAlreadyOpen = false;
      //console.log('------------------------weCLOSE')
    }

  },[isStickText])



  const headTransition = useTransition(showFeatures, {
    from: { transform: `translate(0, ${showFeatures ? 100 : -100}%)` },
    enter: { transform: `translate(0, 0%)` },
    leave: { transform: `translate(0, ${showFeatures ? -100 : 100}%)` },
  })

  const bodyDir = Math.sign(selectedProductIndex - previousIndex || 0)
  const bodyTransition = useTransition(selectedProductIndex, {
    from: { transform: `translate(${100 * bodyDir}%, 0)` },
    enter: { transform: `translate(0%, 0)` },
    leave: { transform: `translate(${-100 * bodyDir}%, 0)` },
  })

  return (
    <Root isShort={isShort} isPortrait={isPortrait}>
      <Head onClick={() => toggleFeatures()}>
        {headTransition((props, item) =>
          item ? (
            <animated.div id="boxkmore" className="Inner" style={props}>
              <span>Collapse</span>
              <div className="Icon">
                <MinusIcon></MinusIcon>
              </div>
            </animated.div>
          ) : (
            <animated.div id="boxkmore" className="Inner" style={props}>
              <span>Know more</span>
              <div className="Icon">
                <PlusIcon></PlusIcon>
              </div>
            </animated.div>
          )
        )}
      </Head>
      <Collapsible collapsed={!showFeatures}>
        <Body isShort={isShort}>
          {bodyTransition((props, item) => (
            <animated.div className="Inner" style={props}>
              <ProductFeatures product={products[item]}></ProductFeatures>
            </animated.div>
          ))}
        </Body>
      </Collapsible>
    </Root>
  )
}

export default FeatureBox
